var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup41(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4",
    "data-name": "Group 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.885,
    height: 20.061,
    viewBox: "0 0 21.885 20.061",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M107.122,128.911h10.031a.456.456,0,1,0,0-.912H107.122a.456.456,0,1,0,0,.912Z",
    transform: "translate(-102.107 -123.44)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M112.593,256h-5.471a.456.456,0,1,0,0,.912h5.471a.456.456,0,1,0,0-.912Z",
    transform: "translate(-102.107 -245.969)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M20.14,23.157c-.026,0-.052.007-.078.008v-.008a1.826,1.826,0,0,0-1.824-1.824H1.824A1.826,1.826,0,0,0,0,23.157V40.938a.456.456,0,0,0,.281.421.451.451,0,0,0,.175.035.456.456,0,0,0,.322-.134L5.2,36.835H18.238a1.826,1.826,0,0,0,1.824-1.824V27.449l1.313-1.312h0a1.745,1.745,0,0,0-1.234-2.979Zm-.99,11.854a.913.913,0,0,1-.912.912H5.015a.456.456,0,0,0-.322.134L.912,39.838V23.157a.913.913,0,0,1,.912-.912H18.238a.913.913,0,0,1,.912.912v.311a1.715,1.715,0,0,0-.244.2l-4.961,4.96H5.015a.456.456,0,1,0,0,.912h8.2l-.438,2.19a.456.456,0,0,0,.447.545.466.466,0,0,0,.089-.009l2.279-.456a.453.453,0,0,0,.233-.125l3.326-3.326Zm-3.873-4.067-1.473.295.295-1.475,4.139-4.139L19.417,26.8Zm5.453-5.452-.668.668L18.882,24.98l.668-.668a.834.834,0,0,1,1.179,1.179Z",
    transform: "translate(0 -21.333)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup41);
export default __webpack_public_path__ + "static/media/Group 4 1.f839f65ae110b061b491af306ca8421e.svg";
export { ForwardRef as ReactComponent };